'use client';

import React from 'react';
import DialogPortalManager from "@/Master/SDialogFC/SDialogManagerFC";

const DialogPortal: React.FC = () => {
    return <DialogPortalManager />;
};

export default DialogPortal;
